module.exports = __webpack_public_path__ + "img/churuku.7d2bab63.png";